<template>
  <div>
    <h3 class="mb-4">Notes</h3>
    <p class="text-xs mb-2">Please add any notes that may be helpful to the design team when they come to artwork your order.</p>
    <textarea
      v-model="orderItem.notes"
      rows="5"
      id="notes"
      class="w-full input bg-white"
      placeholder="Please type any notes for the design team in here."
    ></textarea>
  </div>
</template>
<script>
export default {
  props: ['orderItem']
}
</script>
